import { useEffect } from 'react';
import { Button, Input, Form } from 'antd';
import { useSingleService } from './SingleServiceStore';

function SpecificData({ serviceId, stype }) {
    const { specificFields, specificData, getSpecificFields, addSpecificData, getSpecificData } = useSingleService();

    useEffect(() => {
        if (serviceId) {
            getSpecificData(serviceId);
            getSpecificFields(serviceId);
        }
    }, [serviceId, getSpecificFields, getSpecificData]);


    // {} 
    return (
        <div style={{ padding: '16px 0' }}>
            {
                specificFields.map((field) => {
                    let iv = specificData.find(d => d.key === field.controllername)?.value;
                    iv = iv ? iv : 0;
                    return (
                            <Form style={{ padding: '15px 25px', backgroundColor: 'var(--qk-card-bg)', borderRadius: '15px', marginBottom: '10px' }} key={field.id} layout='vertical' onFinish={(values) => addSpecificData(values, serviceId, field.controllername)}>
                                <Form.Item initialValue={iv} name={'value'} label={field.label}>
                                    <Input type={field.type} />
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType='submit'>Saqlash</Button>
                                </Form.Item>
                            </Form>
                    )
                })
            }
        </div>
    );
}

export default SpecificData;
